module.exports = __webpack_public_path__ + "img/banner-dark.b46ddd76.png";